import React from 'react'
import { Link } from 'gatsby'

import './style.scss'

import data from './menu.json'
import MenuGroup from './menu-group'

import changelog from '../../pages/mt/general/changelog/data.json'

class Menu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      offset: 65,
      sticky: false,
      menuOpen: false,
    }

    this.linkRefs = []
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const currentScroll = window.pageYOffset
    const sticky = this.state.offset < currentScroll

    this.setState({ sticky })
  }

  render() {
    return (
      <div
        className={'menu-container ' + (this.state.sticky && 'menu--sticky')}
      >
        <div
          className={'menu menu--' + this.props.state + ' ' + this.props.site}
        >
          {data[this.props.site].map(({ name, links }) => (
            <MenuGroup name={name} slug={this.props.slug} key={name}>
              {links &&
                links.map(({ name, slug }) => (
                  <Link
                    className="menu__link"
                    activeClassName="menu__link menu__link--active"
                    partiallyActive={true}
                    key={slug}
                    ref={linkRefs => (this.linkRefs[name] = linkRefs)}
                    to={
                      slug &&
                      '/' +
                        this.props.site +
                        '/' +
                        (this.props.state
                          ? slug +
                            (this.props.state ? '/' + this.props.state : '/')
                          : slug + '/design')
                    }
                  >
                    {name}
                  </Link>
                ))}
            </MenuGroup>
          ))}
          <div className="menu__version">
            Version{' '}
            <span className="menu__version-number">
              {changelog.changelog[0].version}
            </span>
          </div>
          <div className="menu__email">
            Send us an email: <br />
            <a
              class="menu__email-address"
              href="mailto:currencydesignsystem@mtb.com"
            >
              currencydesignsystem@mtb.com
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default Menu
